import React from "react";
import ProfileFilterBar from "./ProfileFilterBar";
import authService from "components/api-authorization/AuthorizeService";
import LoadSpinner from "components/LoadSpinner";
import { getRequest, postRequest } from "sharedUtils/httpUtils";
import ProfileHeader from "./ProfileHeader";
import ProfileAboutSection from "./ProfileAboutSection"
import Feed from "components/Feed/Feed";
import ProductFeed from "components/Feed/ProductFeed";
import MessageDetails from "../Account/MessageDetails";
import { connect } from "react-redux";
import { toggleFollowersFollowingModal, closeAllModals, toggleFetchFollowing } from "stateManagement/reducers/modalReducer";
import { getQueryStringParams } from "sharedUtils/navUtils"
import { Helmet } from 'react-helmet';

class Profile extends React.Component {
    state = {
        userInformation: {
            id: 0,
            proStatusId: 0,
            bio: "",
            name: "",
            imageUrl: "",
            tagLine: "",
            userName: "",
            followers: 0,
            following: 0,
            merchantProducts: {
                $values: []
            },
            sectors: {
                $values: []
            }
        },
        loggedInUser: {},
        userPostTabCounts: [],
        profileBanner: "images/Profile-Banner.png",
        uploadingProfileBanner: false,
        followers: 0,
        following: 0,
        isGrid: true,
        lockers: [],
        products: [],
        posts: [],
        activityFeed: [],
        userPostTabs: [],
        selectedTabId: null,
        tabPostState: {},
        showMessageDetails: false,
        isFollowing: false,
        isLoading: true,
        finishedFetching: false,
        finishedFetchingProducts: false,
        selectedFile: {},
        selectedFileUrl: null,
        uploadingBackground: false,
        selectedCase: 3, //1:Activity, 2: Blogs, 3:Lockers, 4:Products, 5:Posts, 6:About
        postCount: 0,
        productCount: 0,
        lockerCount: 0,
        blogs: [],
        finishedFetchingBlogs: false,
        blogCount: 0,
        finishedFetchingActivity: false,
        finishedFetchingLockers: false,
        finishedFetchingPosts: false,
    }

    toggleGrid = () => {
        let newIsGrid = !this.state.isGrid;
        this.setState({ isGrid: newIsGrid });
    }


    async componentDidMount() {
        this.props.setShowTopNav(true, window.location.search.toLowerCase().includes("showbrandnav=") ? this.props.showBrandNav(window.location.search) : true);
        this.props.closeAllModals();
        const userName = this.props.match.params.userName;

        const user = await this.fetchUserInformation(userName);
        if (!user) {
            this.props.history.push("/NotFound");
            return;
        }

        this.setState({ userInformation: user });

        await this.fetchUserPostTabCounts(user.id);

        await Promise.all([
            this.fetchCounts(user.id),
            this.fetchIsFollowing(user.id),
            this.fetchProducts(0, 96),
            this.fetchActivityFeed(0, 12),
            this.fetchLockers(0, 12),
            this.fetchUserPostTabs(user.id)
        ]);

        this.setState({ isLoading: false });

        document.addEventListener("_productAddedEvent", this.updateProducts);
        window.addEventListener("storage", () => {
            const productAdded = new Date(window.localStorage.getItem("productAdded"));
            if (productAdded < new Date()) {
                this.updateProducts();
            }
        });
    }

    fetchUserPostTabs = async (userId) => {
        const url = `/api/Post/GetUserPostTabsByUserId?userId=${userId}`;
        const tabs = await getRequest(url);
        if (!tabs || tabs.length === 0) {
            this.setState({
                userPostTabs: [],
                selectedCase: 3 // fallback to Lockers
            }, () => {
                this.handleFetchLockersTab();
            });
            return;
        }

        const filteredTabs = tabs.filter(
            tab =>
                this.state.userPostTabCounts?.some(c => c.userPostTabId?.toString() === tab.id?.toString() && c.count > 0) 
        );

        const sortedTabs = [...filteredTabs].sort((a, b) => {
            const aOrd = parseInt(a.ordinal);
            const bOrd = parseInt(b.ordinal);
            const aValid = !isNaN(aOrd);
            const bValid = !isNaN(bOrd);

            if (aValid && bValid) return aOrd - bOrd;
            if (aValid) return -1;
            if (bValid) return 1;
            return 0;
        });
        if (sortedTabs.length > 0) {
            const firstTab = sortedTabs[0];
            this.setState({
                userPostTabs: tabs,
                selectedTabId: firstTab.id,
                selectedCase: 1
            }, () => {
                this.fetchPostsByTab(firstTab.id, 0, 24);
            });
        } else {
            this.setState({
                userPostTabs: tabs,
                selectedCase: 3
            }, () => {
                this.handleFetchLockersTab();
            });
        }
    };


    fetchPostsByTab = async (tabId, skip, take) => {
        const urlBase = this.props.loggedInUser ? '/api/post/getPostsByUserAuthorized' : '/api/post/getPostsByUser';
        const url = `${urlBase}?userName=${this.state.userInformation.userName}&skip=${skip}&take=${take}&onlyIncludeByUserPostTabId=true&userPostTabId=${tabId}`;

        const results = await getRequest(url);
        this.setState((prev) => {
            const current = prev.tabPostState[tabId] || { posts: [], finishedFetching: false };
            if (results && Array.isArray(results)) {
                return {
                    tabPostState: {
                        ...prev.tabPostState,
                        [tabId]: {
                            posts: [...current.posts, ...results],
                            finishedFetching: results.length < take
                        }
                    }
                };
            } else {
                return {
                    tabPostState: {
                        ...prev.tabPostState,
                        [tabId]: {
                            posts: [...current.posts,],
                            finishedFetching: true
                        }
                    }
                };
            }

        });
    };

    handleTabClick = (tabId) => {
        this.setState({ selectedTabId: tabId, selectedCase: 1 }, () => {
            if (!this.state.tabPostState[tabId]) {
                this.fetchPostsByTab(tabId, 0, 24);
            }
        });
    };

    displayContent = () => {
        const { selectedCase, selectedTabId, tabPostState } = this.state;

        if (selectedCase === 1 && selectedTabId != null) {
            const tabState = tabPostState[selectedTabId] || { posts: [], finishedFetching: false };
            return (
                <Feed
                    loggedInUser={this.props.loggedInUser}
                    posts={tabState.posts}
                    isGrid={this.state.isGrid}
                    finishedFetching={tabState.finishedFetching}
                    showFollowSuggestions={false}
                    fetchMore={() => this.fetchPostsByTab(selectedTabId, tabState.posts.length, 24)}
                    updateParent={(updates) => this.setState((prev) => ({
                        tabPostState: {
                            ...prev.tabPostState,
                            [selectedTabId]: {
                                ...prev.tabPostState[selectedTabId],
                                posts: updates
                            }
                        }
                    }))}
                    showPins={true}
                    toggleSignUpModal={this.props.toggleSignUpModal}
                    deviceSize={this.props.deviceSize}
                />
            );
        }

        switch (selectedCase) {
            case 2:
                return (
                    <Feed
                        loggedInUser={this.props.loggedInUser}
                        posts={this.state.blogs}
                        isGrid={this.state.isGrid}
                        finishedFetching={this.state.finishedFetchingBlogs}
                        showFollowSuggestions={false}
                        fetchMore={() => this.fetchBlogs(this.state.blogs.length, 24)}
                        updateParent={(updates) => this.setState({ blogs: updates })}
                        showPins={true}
                        toggleSignUpModal={this.props.toggleSignUpModal}
                        deviceSize={this.props.deviceSize}
                    />
                );
            case 3:
                return (
                    <Feed
                        loggedInUser={this.props.loggedInUser}
                        posts={this.state.lockers}
                        isGrid={this.state.isGrid}
                        finishedFetching={this.state.finishedFetchingLockers}
                        showFollowSuggestions={false}
                        fetchMore={() => this.fetchLockers(this.state.lockers.length, 24)}
                        updateParent={(updates) => this.setState({ lockers: updates })}
                        toggleSignUpModal={this.props.toggleSignUpModal}
                        deviceSize={this.props.deviceSize}
                    />
                );
            case 4:
                return (
                    <ProductFeed
                        products={this.state.products}
                        loggedInUser={this.props.loggedInUser}
                        isGrid={this.state.isGrid}
                        finishedFetching={this.state.finishedFetchingProducts}
                        fetchMore={() => this.fetchProducts(this.state.products.length, 96)}
                        toggleSignUpModal={this.props.toggleSignUpModal}
                        deviceSize={this.props.deviceSize}
                    />
                );
            case 6:
                return <ProfileAboutSection userInformation={this.state.userInformation} deviceSize={this.props.deviceSize} />;
            default:
                return null;
        }
    };

    updateProducts = async () => {
        let basePath = this.props.loggedInUser ? "/Products/GetUserMerchantProductsAuthorized" : "/Products/GetUserMerchantProducts";
        let products = await getRequest(`${basePath}/?userName=${this.state.userInformation.userName}&skip=0&take=96&onlyPostedProducts=false`);
        let fullProducts = products?.map((product) => {
            product.user = this.state.userInformation
            return product;
        });
        this.setState({ products: fullProducts });
    }

    componentWillUnmount = () => {
        document.removeEventListener("_productAddedEvent", this.updateProducts);
        window.removeEventListener('storage', () => { });
    }

    async componentDidUpdate(prevProps, prevState) {
        if (this.props.match.params.userName !== prevProps.match.params.userName) {
            this.props.closeAllModals();

            this.setState({
                profileBanner: "images/Profile-Banner.png",
                uploadingProfileBanner: false,
                followers: 0,
                following: 0,
                isGrid: true,
                lockers: [],
                products: [],
                posts: [],
                activityFeed: [],
                showMessageDetails: false,
                isFollowing: false,
                isLoading: true,
                finishedFetching: false,
                finishedFetchingProducts: false,
                selectedFile: {},
                selectedFileUrl: null,
                uploadingBackground: false,
                selectedCase: 1, //1:Activity, 2:Lockers, 3:Products, 4:Posts, 5:About
                postCount: 0,
                productCount: 0,
                lockerCount: 0,
                finishedFetchingActivity: false,
                finishedFetchingLockers: false,
                finishedFetchingPosts: false
            }, async () => {
                let user = await (this.fetchUserInformation(this.props.match.params.userName));
                if (user === undefined || user == null) {
                    this.props.history.push("/NotFound");
                }
                else {
                    this.setState({ userInformation: user });

                    await Promise.all([
                        this.fetchCounts(user.id),
                        this.fetchIsFollowing(user.id),
                        this.fetchProducts(0, 96),
                        this.fetchActivityFeed(0, 24)]);

                    this.setState({ isLoading: false })
                }
            })            
        }
    }

    selectMediaToUpload = (e) => {
        e.preventDefault();
        this.setState({ uploadingProfileBanner: true });
        let selectedFileTempUrl = URL.createObjectURL(e.target.files[0]);
        this.setState({ selectedFile: e.target.files[0], selectedFileUrl: selectedFileTempUrl }, async () => {
            let uploadImageResponse = await this.uploadBackroundImage();
            let userInformation = this.state.userInformation;
            userInformation.profileBannerUrl = uploadImageResponse.profileBannerUrl;

            this.setState({ userInformation, uploadingProfileBanner: false });
        })
    }

    uploadBackroundImage = async () => {
        if (this.state.selectedFile != null) {
            const formData = new FormData();
            formData.append(`profileBanner`, this.state.selectedFile);

            let url = `/api/Account/UploadProfileBannerPic`;
            let newProperties = await postRequest(url, formData, null, false);
            this.props.setLoggedInUser(newProperties);
            return newProperties;
        }
        else return null;
    }

    fetchUserInformation = async (username) => {
        let url = `/api/account/getProfile?userName=${username}`;
        let data = await getRequest(url);
        if (data == null || data == undefined) {
            return null;
        }
        else {
            const trackingShareLink = window.location.href;

            const params = getQueryStringParams(window.location.search);
            const referrer = params.referrer ?? null;

            const utmId = params.utm_id ?? null;
            const utmSource = params.utm_source ?? null;
            const utmMedium = params.utm_medium ?? null;
            const utmName = params.utm_name ?? null;
            const utmContent = params.utm_content ?? null;
            const utmTerm = params.utm_term ?? null;

            const isValid = (v) => typeof v === 'string' && v.length > 0;

            let trackingUrl = `/api/account/trackProfileView${!!(this.props.loggedInUser) ? "Authorized" : ""}?creatorUserId=${data.id}&referrer=${referrer ?? encodeURIComponent(document.referrer)}&shareLink=${encodeURIComponent(trackingShareLink)}`;

            if (isValid(utmId)) trackingUrl += `&utmId=${encodeURIComponent(utmId)}`;
            if (isValid(utmSource)) trackingUrl += `&utmSource=${encodeURIComponent(utmSource)}`;
            if (isValid(utmMedium)) trackingUrl += `&utmMedium=${encodeURIComponent(utmMedium)}`;
            if (isValid(utmName)) trackingUrl += `&utmName=${encodeURIComponent(utmName)}`;
            if (isValid(utmContent)) trackingUrl += `&utmContent=${encodeURIComponent(utmContent)}`;
            if (isValid(utmTerm)) trackingUrl += `&utmTerm=${encodeURIComponent(utmTerm)}`;

            await getRequest(trackingUrl);

            this.setState({ userInformation: data }, async () => {
                if (data.proStatusId !== 1) {
                    this.setState({ selectedCase: 5 });
                }
                await this.fetchIsFollowing(this.state.userInformation.id)
            });
            return data;
        }               
    }

    fetchCounts = async (userId) => {
        let url = `api/Post/GetPostCount?userId=${userId}&onlyPublished=true`;
        let count = await getRequest(url);

        let sum = count.length > 0
            ? count.reduce((a, b) => ({ count: a.count + b.count }))
            : { count: 0 };

        let totalCount = sum.count;

        // Find locker count (userPostTypeId = 2)
        let lockerCount = 0;
        let lockers = count.find(({ userPostTypeId }) => userPostTypeId === 2);
        if (lockers) {
            lockerCount = lockers.count;
        }

        // Find blog count (userPostTypeId = 4)
        let blogCount = 0;
        let blogs = count.find(({ userPostTypeId }) => userPostTypeId === 4);
        if (blogs) {
            blogCount = blogs.count;
        }

        // Get product count
        let productCountUrl = `/Products/GetUserMerchantProductCount?userId=${userId}&onlyPostedProducts=false`;
        let productCount = (await getRequest(productCountUrl)).count;

        // Set state with post count excluding lockers and blogs
        this.setState({
            postCount: totalCount - lockerCount - blogCount,
            lockerCount,
            blogCount,
            productCount
        });
    }

    fetchUserPostTabCounts = async (userId) => {
        let url = `api/Post/GetPostCountByUserPostTab?userId=${userId}&onlyPublished=true`;
        let count = await getRequest(url);
        this.setState({
            userPostTabCounts: count
        });
    }

    fetchUserPostTabsNotMount = async (userId) => {
        let url = `/api/Post/GetUserPostTabsByUserId?userId=${userId}`;
        let data = await getRequest(url);
        this.setState({ userPostTabs: data });
    }

    fetchIsFollowing = async (userId) => {
        let url = `/api/Account/IsFollowing?id=${userId}`;
        let data = await getRequest(url);
        this.setState({ isFollowing: data });
    }

    fetchActivityFeed = async (skip, take) => {
        let url = this.props.loggedInUser != null ? '/api/post/getPostsByUserAuthorized' : '/api/post/getPostsByUser';

        let data = await getRequest(`${url}?userName=${this.state.userInformation.userName}&skip=${skip}&take=${take}&onlyPosts=false&onlyLockers=false&onlyIncludeByUserPostTabId=false&userPostTabId=&onlyPostsNoBlogs=true`);

        let lockers = data.filter((post) => post.type === 2);
        let lockerIds = this.state.lockers.map((locker) => locker.id);

        let posts = data.filter((post) => post.type !== 2);
        let postIds = this.state.posts.map((post) => post.id);

        let lockersToAdd = lockers.filter((locker) => !lockerIds.includes(locker.id));
        let postsToAdd = posts.filter((post) => !postIds.includes(post.id));

        this.setState({
            activityFeed: this.state.activityFeed.concat(data),
            finishedFetchingActivity: data.length < take ? true : false,
            finishedFetchingPosts: data.length < take ? true : this.state.finishedFetchingPosts,
            finishedFetchingLockers: data.length < take ? true : this.state.finishedFetchingLockers,
            lockers: [...this.state.lockers, ...lockersToAdd],
            posts: [...this.state.posts, ...postsToAdd]
        });
    }

    fetchProducts = async (skip, take) => {
        this.setState({ finishedFetchingProducts: false })

        let basePath = this.props.loggedInUser ? "/Products/GetUserMerchantProductsAuthorized" : "/Products/GetUserMerchantProducts";

        let products = await getRequest(`${basePath}?userName=${this.state.userInformation.userName}&skip=${skip}&take=${take}&onlyPostedProducts=false`);
        let fullProducts = products.map((product) => {
            product.user = this.state.userInformation
            return product;
        });

        let productList = [...this.state.products, ...fullProducts];

        this.setState({ products: productList });

        if (!take) {
            this.setState({ finishedFetchingProducts: true })
        } else if (products.length < take) {
            this.setState({ finishedFetchingProducts: true })
        }
    }

    fetchLockers = async (skip, take) => {
        var postResults = await getRequest(`/api/post/getPostsByUser?userName=${this.state.userInformation.userName}&skip=${skip}&take=${take}&onlyLockers=true`);

        let lockers = postResults.filter((post) => post.type === 2);
        let lockerIds = this.state.lockers.map((locker) => locker.id);

        let lockersToAdd = lockers.filter((locker) => !lockerIds.includes(locker.id));

        this.setState({ lockers: [...this.state.lockers, ...lockersToAdd], finishedFetchingLockers: postResults.length < take ? true : false });
    }

    fetchPosts = async (skip, take) => {
        var postResults = await getRequest(`/api/post/getPostsByUser?userName=${this.state.userInformation.userName}&skip=${skip}&take=${take}&onlyPosts=true`);

        let posts = postResults.filter((post) => post.type === 1 || post.type === 3);
        let postIds = this.state.posts.map((post) => post.id);
        let postsToAdd = posts.filter((post) => !postIds.includes(post.id));

        this.setState({ posts: [...this.state.posts, ...postsToAdd], finishedFetchingPosts: postResults.length < take ? true : false });
    }

    fetchBlogs = async (skip, take) => {
        let url = this.props.loggedInUser != null ? '/api/post/getPostsByUserAuthorized' : '/api/post/getPostsByUser';
        let blogResults = await getRequest(`${url}?userName=${this.state.userInformation.userName}&skip=${skip}&take=${take}&onlyPosts=false&onlyLockers=false&onlyIncludeByUserPostTabId=false&userPostTabId=&onlyPostsNoBlogs=false&onlyBlogs=true`);

        let blogs = blogResults.filter((blog) => blog.type === 4);
        let blogIds = this.state.posts.map((blog) => blog.id);
        let blogsToAdd = blogs.filter((blog) => !blogIds.includes(blog.id));

        this.setState({ blogs: [...this.state.blogs, ...blogsToAdd], finishedFetchingBlogs: blogResults.length < take ? true : false });
    }

    followOrUnfollow = async () => {
        const prevIsFollowing = this.state.isFollowing;
        this.setState({ isFollowing: !this.state.isFollowing });
        await this.props.toggleFetchFollowing();
        let token = await authService.getAccessToken();

        let url = "/api/Account/"
        if (prevIsFollowing) {
            url += "Unfollow"
        } else {
            url += "Follow"
        }
        url += "?id=" + this.state.userInformation.id;

        const response = await fetch(url,
            {
                headers: !token ? {} : { Authorization: `Bearer ${token}` },
            });

        if (response.ok) {
            this.setState(() => {
                let { followers } = this.state.userInformation;
                let newCount = this.state.isFollowing === false ? (followers - 1) : (followers + 1);
                let newState = { ...this.state };
                newState.userInformation.followers = newCount;
                this.setState(newState);

            });

        //    if (!this.props.fetchFollowing) this.props.toggleFetchFollowing();
        }
    }

    onClickMessage = async () => {
        this.setState({ showMessageDetails: true });
    }

    onClickBack = async () => {
        this.setState({ showMessageDetails: false });
    }

    displayFilterBar = () => {
        if (this.state.selectedCase !== 5) {
            return <ProfileFilterBar toggleAction={this.toggleGrid} isGrid={this.state.isGrid} />
        }
    }

    handleFetchLockersTab = () => {
        if (this.state.lockers.length === 0 && !this.state.finishedFetchingLockers) {
            this.fetchLockers(0, 24);
        }
        this.setState({ selectedCase: 3 });
    }

    handleFetchBlogsTab = () => {
        this.setState({ selectedCase: 2 }, () => {
            if (!this.state.finishedFetchingBlogs && this.state.blogs.length === 0) {
                this.fetchBlogs(0, 24);
            }
        });
    };

    render() {
        let { selectedCase, isLoading } = this.state;
        let { name, imageUrl, proStatusId, tagLine, userName, followers, following } = this.state.userInformation;
        if (isLoading === true) {
            return (
                <>
                    < LoadSpinner />
                        <Helmet>
                        <title>RockPorch - Profile: {!!(this.props.match.params.userName) ? this.props.match.params.userName : ""}</title>
                        </Helmet>
                </>
            )
        }
        else if (this.state.userInformation === "notFound") {
            return (
                <>
                    <h1>This user does not exist</h1>
                    <Helmet>
                        <title>RockPorch - Profile: {!!(this.props.match.params.userName) ? this.props.match.params.userName : ""}</title>
                    </Helmet>
                </>
            )
        }
        else {
            if (this.state.showMessageDetails) {
                return (
                    <>
                        <MessageDetails onClickBack={this.onClickBack} user={this.state.userInformation} loggedInUser={this.props.loggedInUser} />
                        <Helmet>
                            <title>RockPorch - Profile: {!!(this.props.match.params.userName) ? this.props.match.params.userName : ""}</title>
                        </Helmet>
                    </>
                )
            }

            return (
                <section>
                    <Helmet>
                        <title>RockPorch - Profile: {!!(this.props.match.params.userName) ? this.props.match.params.userName : ""}</title>
                    </Helmet>
                    <ProfileHeader
                        deviceSize={this.props.deviceSize}
                        showFollowersOrFollowing={(text) => {
                            if (this.props.loggedInUser) {
                                this.props.toggleFollowersFollowingModal(this.state.userInformation.id, text, null)
                            }
                            else {
                                this.props.toggleSignUpModal()
                            }

                        }}
                        userInformation={this.state.userInformation}
                        fetchProducts={() => this.setState({ selectedCase: 4 })}
                        fetchActivityFeed={() => this.setState({ selectedCase: 1 })}
                        fetchPosts={() => this.setState({ selectedCase: 5 })}
                        fetchBlogs={this.handleFetchBlogsTab}
                        fetchLockers={this.handleFetchLockersTab}
                        selectedCase={selectedCase}
                        isAuthenticated={this.props.loggedInUser !== undefined}
                        isLoggedInUser={this.props.loggedInUser?.userName === userName}
                        loggedInUser={this.props.loggedInUser}
                        setLoggedInUser={this.props.setLoggedInUser}
                        isFollowing={this.state.isFollowing}
                        followAction={this.followOrUnfollow}
                        onClickMessage={this.onClickMessage}
                        productCount={this.state.productCount}
                        postCount={this.state.postCount}
                        blogCount={this.state.blogCount}
                        lockerCount={this.state.lockerCount}
                        fetchAbout={() => this.setState({ selectedCase: 5 })}
                        uploadingProfileBanner={this.state.uploadingProfileBanner}
                        location={this.props.location}
                        toggleSignUpModal={this.props.toggleSignUpModal}
                        hamOpen={this.props.hamOpen}
                        setToggleMenu={this.props.setToggleMenu}
                        setHomeFeedSaveUser={this.props.setHomeFeedSaveUser}
                        setExploreSaveUser={this.props.setExploreSaveUser}
                        screenWidth={this.props.screenWidth}
                        userPostTabs={this.state.userPostTabs}
                        onTabClick={this.handleTabClick}
                        selectedTabId={this.state.selectedTabId}
                        userPostTabCounts={this.state.userPostTabCounts}
                    />

                    <input type="file"
                        accept="image/png,image/jpeg"
                        name="files"
                        id="uploadProfileBanner"
                        onChange={(e) => this.selectMediaToUpload(e)}
                        style={{ display: "none" }}
                    />

                    {this.displayFilterBar()}

                    <div className="container-fluid gray-bg full-height explore-feed-wrapper px-0">

                        <div className="row m-0">
                            <div className="container px-0 px-md-5 mt-1 top-section-child">
                                {this.displayContent()}
                            </div>
                        </div>


                    </div>

                </section>
            )
        }

    }
}

function mapStateToProps(storeState, componentProps) {
    let result = { fetchFollowing: storeState.modalReducer.fetchFollowing }
    return result;
}

export default connect(mapStateToProps, { toggleFollowersFollowingModal, closeAllModals, toggleFetchFollowing })(Profile);